var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SelectMainStyle"},[_c('div',{staticClass:"tips"},[_c('h1',[_vm._v("Web3 Wallet")]),_c('p',[_vm._v(_vm._s(_vm.$t('network.ev')))]),_c('button',{staticClass:"btnConnect"},[_vm._v("Connect Wallet")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }